var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRecurringPeople = function SvgRecurringPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.82 13.134a.64.64 0 0 1 .18.352l.007.1v5.57a.64.64 0 0 1-1.271.1l-.008-.1V15.13l-6.565 6.566a.64.64 0 0 1-.746.116l-.087-.054-.072-.062a.64.64 0 0 1-.062-.833l.062-.072 6.564-6.566-4.026.001a.64.64 0 0 1-.597-.44l-.023-.097-.009-.103a.64.64 0 0 1 .529-.63l.103-.01h5.569a.64.64 0 0 1 .452.188zM14.732 1.3a.64.64 0 0 1 .062.833l-.062.072-6.565 6.564h4.027a.64.64 0 0 1 .596.44l.024.098.008.103a.64.64 0 0 1-.528.63l-.103.01H6.622a.64.64 0 0 1-.632-.54l-.008-.1V3.838a.64.64 0 0 1 1.27-.1l.01.103v4.023L13.827 1.3a.64.64 0 0 1 .746-.117l.087.055.072.062z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgRecurringPeople;